import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const InstitutionDashboard = () => {
  const navigate = useNavigate();
  const [institution, setInstitution] = useState(null);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [activeTab, setActiveTab] = useState('profile');
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [filters, setFilters] = useState({
    city: '',
    state: '',
    name: '',
    phone: ''
  });

  useEffect(() => {
    // Check authentication
    const userData = localStorage.getItem('userData');
    const currentUserData = localStorage.getItem('currentUserData');

    if (!userData || !currentUserData) {
      navigate('/login');
      return;
    }

    const user = JSON.parse(userData);
    const institutionData = JSON.parse(currentUserData);

    if (user.role !== 'institution') {
      navigate('/');
      return;
    }

    setInstitution(institutionData);

    // Load students assigned to this institution
    const studentAssignments = JSON.parse(localStorage.getItem('studentAssignments') || '[]');
    const institutionStudents = studentAssignments.filter(s => s.assignedTo === institutionData.id && s.assignedToType === 'institution');

    // Try to get users from localStorage first, otherwise use mock data
    let allUsers = JSON.parse(localStorage.getItem('adminUsers') || '[]');

    const students = institutionStudents.map(assignment => {
      const user = allUsers.find(u => u.id === assignment.studentId);
      return user ? { ...user, assignmentId: assignment.id } : null;
    }).filter(Boolean);

    setAssignedStudents(students);
    setFilteredStudents(students);
  }, [navigate]);

  // Refresh students when switching to students tab
  useEffect(() => {
    if (activeTab === 'students') {
      const userData = localStorage.getItem('userData');
      const currentUserData = localStorage.getItem('currentUserData');

      if (userData && currentUserData) {
        const user = JSON.parse(userData);
        const institutionData = JSON.parse(currentUserData);

        if (user.role === 'institution') {
          const studentAssignments = JSON.parse(localStorage.getItem('studentAssignments') || '[]');
          const institutionStudents = studentAssignments.filter(s => s.assignedTo === institutionData.id && s.assignedToType === 'institution');

          let allUsers = JSON.parse(localStorage.getItem('adminUsers') || '[]');

          const students = institutionStudents.map(assignment => {
            const user = allUsers.find(u => u.id === assignment.studentId);
            return user ? { ...user, assignmentId: assignment.id } : null;
          }).filter(Boolean);

          setAssignedStudents(students);
          setFilteredStudents(students);
        }
      }
    }
  }, [activeTab]);

  useEffect(() => {
    // Apply filters
    let filtered = assignedStudents;

    if (filters.name) {
      filtered = filtered.filter(s => s.name.toLowerCase().includes(filters.name.toLowerCase()));
    }

    if (filters.city) {
      filtered = filtered.filter(s => s.city && s.city.toLowerCase().includes(filters.city.toLowerCase()));
    }

    if (filters.state) {
      filtered = filtered.filter(s => s.state && s.state.toLowerCase().includes(filters.state.toLowerCase()));
    }

    if (filters.phone) {
      filtered = filtered.filter(s => s.phone && s.phone.includes(filters.phone));
    }

    setFilteredStudents(filtered);
  }, [filters, assignedStudents]);

  const handleLogout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('currentUserData');
    navigate('/login');
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!institution) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="dashboard-container" style={{top:'40px'}}>
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Yoga Institution Dashboard</h1>
          <p>Welcome, {institution.institutionName}</p>
        </div>
        {/* <button onClick={handleLogout} className="logout-btn">Logout</button> */}
      </div>

      <div className="dashboard-tabs">
        <button
          className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          Profile Details
        </button>
        <button
          className={`tab-btn ${activeTab === 'students' ? 'active' : ''}`}
          onClick={() => setActiveTab('students')}
        >
          Assigned Students ({assignedStudents.length})
        </button>
      </div>

      <div className="dashboard-content">
        {/* Profile Tab */}
        {activeTab === 'profile' && (
          <div className="profile-section">
            <h2 style={{color:'white'}}>Institution Profile</h2>
            <div className="profile-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="institutionName">Institution Name</label>
                  <input
                    type="text"
                    id="institutionName"
                    value={institution.institutionName}
                    readOnly
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={institution.email}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone" className="form-label">Phone</label>
                  <input
                    type="tel"
                    id="phone"
                    value={institution.phone}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="address" className="form-label">Address</label>
                  <input
                    type="text"
                    id="address"
                    value={institution.address}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city" className="form-label">City</label>
                  <input
                    type="text"
                    id="city"
                    value={institution.city}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="state" className="form-label">State</label>
                  <input
                    type="text"
                    id="state"
                    value={institution.state}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="postalCode" className="form-label">Postal Code</label>
                  <input
                    type="text"
                    id="postalCode"
                    value={institution.postalCode}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="country" className="form-label">Country</label>
                  <input
                    type="text"
                    id="country"
                    value={institution.country}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="foundingYear" className="form-label">Founding Year</label>
                  <input
                    type="number"
                    id="foundingYear"
                    value={institution.foundingYear}
                    readOnly
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="charges" className="form-label">Charges</label>
                  <input
                    type="text"
                    id="charges"
                    value={institution.charges || ''}
                    readOnly
                    className="form-input"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Students Tab */}
        {activeTab === 'students' && (
          <div className="students-section">
            <h2>Assigned Students</h2>

            <div className="filters-section">
              <input
                type="text"
                name="name"
                placeholder="Filter by student name"
                value={filters.name}
                onChange={handleFilterChange}
                className="filter-input"
              />
              <input
                type="text"
                name="city"
                placeholder="Filter by city"
                value={filters.city}
                onChange={handleFilterChange}
                className="filter-input"
              />
              <input
                type="text"
                name="state"
                placeholder="Filter by state"
                value={filters.state}
                onChange={handleFilterChange}
                className="filter-input"
              />
              <input
                type="text"
                name="phone"
                placeholder="Filter by phone"
                value={filters.phone}
                onChange={handleFilterChange}
                className="filter-input"
              />
            </div>

            {filteredStudents.length > 0 ? (
              <div className="table-responsive">
                <table className="students-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Address</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.map(student => (
                      <tr key={student.id}>
                        <td><strong>{student.name}</strong></td>
                        <td>{student.email}</td>
                        <td>{student.phone || 'N/A'}</td>
                        <td>{student.city || 'N/A'}</td>
                        <td>{student.state || 'N/A'}</td>
                        <td>{student.address || 'N/A'}</td>
                        <td><span className="status-badge">{student.status || 'Active'}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="no-data">No students assigned yet.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InstitutionDashboard;
